import React, { useMemo, useState } from 'react';
import cn from 'classnames';
import Tags from 'components/UI/Tags';
import Loader from 'components/UI/Loader';
import ContentItem from './ContentItem';
import { useTrans } from 'utils/localisation';

import * as styles from './Content.module.scss';

export default function Content({ cards, loading, eventsPage }) {
  const t = useTrans(['events']);
  const targetDate = formatDate(new Date());

  const [active, setActive] = useState('upcoming');
  const [opacity, setOpacity] = useState({
    '--opacity': 1,
  });

  const setActiveTab = type => {
    setOpacity({ '--opacity': 0.1 });
    setTimeout(() => {
      setActive(type);
      setOpacity({ '--opacity': 1 });
    }, 200);
  };

  const { futureCardList, previousCardList } = useMemo(() => {
    const futureCardList = cards
      ?.filter(({ finishDate }) => finishDate >= targetDate)
      .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
    const previousCardList = cards
      ?.filter(({ finishDate }) => finishDate < targetDate)
      .sort((a, b) => new Date(b.startDate) - new Date(a.startDate));

    return { futureCardList, previousCardList };
  }, [cards, targetDate]);

  const displayTags = futureCardList?.length >= 1;

  const tabsContent = useMemo(() => {
    return [
      {
        name: t('upcomingTab'),
        type: 'upcoming',
        cards: futureCardList || [],
      },
      {
        name: t('previousTab'),
        type: !futureCardList?.length ? 'upcoming' : 'previous',
        cards: previousCardList || [],
      },
    ].filter(tab => tab.cards.length > 0);
  }, [futureCardList, previousCardList]);

  return (
    <div className={cn(styles.wrapper, displayTags && styles.withTags)}>
      {loading ? (
        <Loader theme="fullHeight" />
      ) : (
        <>
          {cards ? (
            <>
              {displayTags && (
                <Tags
                  className={styles.tags}
                  active={active}
                  handleClick={setActiveTab}
                  tags={tabsContent}
                />
              )}
              <div className={styles.content} style={opacity}>
                {tabsContent.map(({ type, cards }) => (
                  <div hidden={active !== type} key={type}>
                    <ContentItem cards={cards} limiter={eventsPage ? 6 : 3} />
                  </div>
                ))}
              </div>
            </>
          ) : null}
        </>
      )}
    </div>
  );
}

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
